import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Loading from "../components/loading";
import { helpingCenterDetailsPage, helpingCenterPageHeading} from "../api/helping-center-page";
import "../stylesheets/helpingCenterDetailsPage.css";
import { DISPLAY_LANG } from "../config";

export default function HelpingCenterDetailsPage() {
  const { id } = useParams();
  const [pageData, setPageData] = useState({});
  const [loading, setLoading] = useState(true);
  const [heading, setHeading] = useState({});

  useEffect(() => {
    const loadingData = async () => {
      try {
        const resDataById = await helpingCenterDetailsPage();
        const getailById = resDataById.find((elem) => elem.id === parseInt(id));
        setPageData(getailById);
        const resHeading = await helpingCenterPageHeading();
        setHeading(resHeading[0].title);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    loadingData();
    window.scrollTo(0, 0);
  }, [id]);

  if (loading) {
    return <Loading />;
  }
  // Ստեղծում ենք embed URL-ը
  const getEmbedUrl = (url) => {
    if (!url) return "";
    const videoId = url.split("v=")[1]?.split("&")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  };

  return (
    <div className="HelpingCenterDetailsPage wrapper">
      <Link to={"/helping-center"} className="helping-link">
        <img
          className="arrow-left"
          src="/images/partials/arrow.svg"
          alt="arrow"
        />
        <span>{heading[DISPLAY_LANG]}</span>
      </Link>
      <h2 className="helpingCenter-title">{pageData.title}</h2>

      {pageData.youtube_link && (
        <div className="video-container">
          <iframe
            src={getEmbedUrl(pageData.youtube_link)}
            title={pageData.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      )}

      {pageData.help_center_text &&
        pageData.help_center_text.map((text) => (
          <p key={text.id}>{text.description}</p>
        ))}
    </div>
  );
}
